import state from './moduleTicketState.js'
import actions from "./moduleTicketActions";
import mutations from './moduleTicketMutations'



export default {
    isRegistered: false,
    namespaced: true,
    mutations: mutations,
    state: state,
    actions: actions,
}
